export const appConfig = {
	title: 'Remote Social Connect',
	baseUrl: 'remotesocial.io',
	subdomain: 'connect',
};
